export const TUTOR_STATUS = [
  { id: -1, label: 'All' },
  { id: 1, label: 'Active' },
  { id: 2, label: 'Temporarly Inactive' },
];

export const TUTOR_UTILIZATION = [
  { id: -1, label: 'All' },
  { id: 1, label: 'Utilized' },
  { id: 2, label: 'Non-Utilized' },
];

export const genders = [
  { id: -1, name: 'All' },
  { id: 'female', name: 'Female' },
  { id: 'male', name: 'Male' },
];

export const RATING = [
  { id: -1, name: 'All' },
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
  { id: 5, name: '5' },
];
